import * as tslib_1 from "tslib";
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import React from 'react';
import styled from 'styled-components';
import IconButton from 'sinoui-components/IconButton';
import Icon from 'sinoui-components/Icon';
import CalendarHeaderLayout from './CalendarHeaderLayout';
import YearMonthSelect from './YearMonthSelect';
var SpaceColumn = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  flex: 1 1 auto;\n"], ["\n  flex: 1 1 auto;\n"])));
export default function CalendarHeader(props) {
    var yearSelectButtonMessage = getYearSelectButtonMessage(props.monthChecked, props.yearChecked, props.prevAndNext, props.modelState);
    return (React.createElement(CalendarHeaderLayout, null,
        React.createElement(YearMonthSelect, { onClickYearMonthSelect: props.onClickYearMonthSelect, 
            // yearMonthMessage={props.yearMonthMessage}
            monthLastChecked: props.monthLastChecked, yearLastChecked: props.yearLastChecked, monthChecked: props.monthChecked, yearChecked: props.yearChecked, modelState: props.modelState, yearSelectButtonMessage: yearSelectButtonMessage }),
        React.createElement(SpaceColumn, null),
        React.createElement(PrevButton, { onClickPrevButton: props.onClickPrevButton }),
        React.createElement(NextButton, { onClickNextButton: props.onClickNextButton })));
}
function PrevButton(props) {
    return (React.createElement(IconButton, { onClick: props.onClickPrevButton },
        React.createElement(Icon, null,
            React.createElement(MdChevronLeft, null))));
}
function NextButton(props) {
    return (React.createElement(IconButton, { onClick: props.onClickNextButton },
        React.createElement(Icon, null,
            React.createElement(MdChevronRight, null))));
}
function getYearSelectButtonMessage(monthChecked, yearChecked, prevAndNext, modelState) {
    var returnMessage;
    if (modelState === 1) {
        var remainderYear = yearChecked % 24;
        var pageFirstYear = yearChecked - remainderYear;
        var changePageFirstYear = pageFirstYear + 24 * prevAndNext;
        if (changePageFirstYear <= 2) {
            changePageFirstYear = 1990;
        }
        returnMessage = changePageFirstYear + '-' + (changePageFirstYear + 24);
    }
    if (modelState === 2) {
        returnMessage = yearChecked;
    }
    if (modelState === 0) {
        returnMessage =
            yearChecked + '-' + monthChecked.toString().padStart(2, '0');
    }
    return returnMessage;
}
var templateObject_1;
//# sourceMappingURL=CalendarHeader.js.map